@if (timesheet.clocked_in) {
  <span class="timesheet-info-block">
    <span class="timesheet-info-block-title">{{ 'Clocked in' | translate }}: </span>
    {{ timesheet.clocked_in | date: 'HH:mm:ss' }}
    @if (timesheet['ClockedInOrigin']) {
      {{ 'via' | translate }} {{ timesheet['ClockedInOrigin'] }}
    }
    <clock-location-point
      [lat]="timesheet.clocked_in_latitude"
      [lon]="timesheet.clocked_in_longitude"
      [title]="'Clocked in' | translate"
    ></clock-location-point>
  </span>
}
@if (timesheet.ClockBreak?.length > 0) {
  @for (clockBreak of timesheet.ClockBreak; track clockBreak.clocked_in) {
    <span class="timesheet-info-block">
      <span class="timesheet-info-block-title">{{ 'Break' | translate }}: </span>
      {{ clockBreak.clocked_in | date: 'HH:mm:ss' }}
      <clock-location-point
        [lat]="clockBreak.clocked_in_latitude"
        [lon]="clockBreak.clocked_in_longitude"
        [title]="'Clocked in' | translate"
      />
      -
      {{ clockBreak.clocked_out | date: 'HH:mm:ss' }}
      <clock-location-point
        [lat]="clockBreak.clocked_out_latitude"
        [lon]="clockBreak.clocked_out_longitude"
        [title]="'Break start' | translate"
      />
    </span>
  }

  <span class="timesheet-info-block">
    <span class="timesheet-info-block-title">{{ 'Total break' | translate }}: </span>
    {{ timesheet.clocked_break | calculateBreakTime }}
  </span>
}

@if (timesheet.clocked_out) {
  <span class="timesheet-info-block">
    <span class="timesheet-info-block-title">{{ 'Clocked out' | translate }}: </span>
    {{ timesheet.clocked_out | date: 'HH:mm:ss' }}
    @if (timesheet['ClockedOutOrigin']) {
      {{ 'via' | translate }} {{ timesheet['ClockedOutOrigin'] }}
    }

    <clock-location-point
      [lat]="timesheet.clocked_out_latitude"
      [lon]="timesheet.clocked_out_longitude"
      [title]="'Clocked out' | translate"
    />
  </span>
}
